import REGEX from"./regex.js";function validate(uuid){return"string"==typeof uuid&&REGEX.test(uuid)}export default validate;